import React from 'react';
import './Hero.css';

const LEAVES = ['🌿', '🍃', '🌱', '🍀', '🌾'];
const particles = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  emoji: LEAVES[i % LEAVES.length],
  left: `${(i * 5.5 + 3) % 100}%`,
  delay: `${(i * 0.7) % 12}s`,
  duration: `${10 + (i % 7) * 1.5}s`,
}));

export default function Hero() {
  return (
    <section className="hero" id="hero">
      <img className="hero-video" src="/Thumbnail.jpg" alt="Adiyogi Natural Farms" />
      <div className="hero-overlay" />

      {/* floating leaf particles */}
      <div className="hero-particles">
        {particles.map(({ id, emoji, left, delay, duration }) => (
          <span
            key={id}
            style={{ left, animationDelay: delay, animationDuration: duration }}
          >
            {emoji}
          </span>
        ))}
      </div>

      <div className="hero-content">
        <div className="hero-badge">🌿 100% Natural &amp; Chemical Free</div>
        <h1>
          Adiyogi
          <span className="highlight">Natural Farms</span>
        </h1>
        <p className="hero-tagline">
          Pure 🌿 Organic 🌿 From Our Soil to Your Soul 🌿
        </p>
        <div className="hero-actions">
          <a href="#products" className="hero-btn">Explore Products</a>
          <a href="#gallery" className="hero-btn-outline">See Our Farm</a>
        </div>
      </div>

      <div className="hero-stats">
        <div className="stat-item">
          <span className="stat-num">100%</span>
          <span className="stat-label">Chemical Free</span>
        </div>
        <div className="stat-item">
          <span className="stat-num">50+</span>
          <span className="stat-label">Happy Customers</span>
        </div>
        <div className="stat-item">
          <span className="stat-num">10+</span>
          <span className="stat-label">Years Farming</span>
        </div>
        {/* <div className="stat-item">
          <span className="stat-num">5★</span>
          <span className="stat-label">Rated</span>
        </div> */}
      </div>

      <div className="hero-scroll">
        <div className="scroll-dot" />
        <span>Scroll</span>
      </div>
    </section>
  );
}
